<template>
  <v-row class="d-flex justify-center mt-0">
    <v-col cols="12">
      <v-expansion-panels v-model="panel">
        <v-expansion-panel readonly>
          <v-btn
            style="position: absolute; top: -15px; right: 55px; z-index: 1"
            color="success"
            title="Nuevo turno"
            small
            fab
            @click="open_dialog(null)"
          >
            <v-icon>fas fa-plus</v-icon>
          </v-btn>
          <v-expansion-panel-header class="py-0 px-4 text-h5" style="cursor: default">
            <div>
              <v-icon class="mb-1" left>fas fa-filter</v-icon>
              Filtro
            </div>
            <template v-slot:actions>
              <v-btn icon @click.stop="panel = panel === 1 ? 0 : 1">
                <v-icon>fas fa-chevron-down</v-icon>
              </v-btn>
            </template>
          </v-expansion-panel-header>
          <v-expansion-panel-content class="pt-1">
            <v-form @submit.prevent="buscar()">
              <v-row :no-gutters="$vuetify.breakpoint.xs">
                <v-col cols="12" sm="6" md="2" class="py-0">
                  Tipo
                  <v-autocomplete
                    v-model="filtro.tipo"
                    :items="$store.state.tipos_turno"
                    hide-details
                    clearable
                    autofocus
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="py-0">
                  Estado
                  <v-autocomplete
                    v-model="filtro.estado"
                    item-text="nombre"
                    item-value="nombre"
                    :items="$store.state.estados_turno"
                    hide-details
                    clearable
                    outlined
                    dense
                  ></v-autocomplete>
                </v-col>
                 <v-col cols="12" sm="6" md="3" class="py-0">
                  Cliente
                  <v-text-field
                    v-model.trim="filtro.cliente"
                    hide-details
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="2" class="py-0">
                  Fecha desde
                  <FechaPicker
                    :p_fecha.sync="filtro.fecha_desde"
                    :hideDetails="true"
                    :clearable="true"
                  />
                </v-col>
                 <v-col cols="12" sm="6" md="2" class="py-0">
                  Fecha hasta
                  <FechaPicker
                    :p_fecha.sync="filtro.fecha_hasta"
                    :hideDetails="true"
                    :clearable="true"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="1">
                  <v-switch
                    v-model="filtro.activo"
                    label="Activo"
                    :true-value="1"
                    :false-value="0"
                    hide-details
                  ></v-switch>
                </v-col>
                <v-col class="d-flex justify-end align-end mt-4">
                  <v-btn
                    title="Limpiar filtro"
                    color="orange"
                    class="mr-4"
                    icon
                    @click="limpiar()"
                  >
                    <v-icon>fas fa-broom</v-icon>
                  </v-btn>
                  <v-btn
                    color="info"
                    type="submit"
                    :loading="load"
                  >
                    Buscar
                    <v-icon right>fas fa-search</v-icon>
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
      
      <v-data-table
        class="elevation-2 mt-2"
        :headers="headers"
        :items="turnos"
        :loading="load"
        :search="search"
        :sort-by="['timestamp', 'hora']"
        multi-sort
        dense
      >
        <template v-slot:top>
          <v-row class="d-flex justify-end pa-3" no-gutters>
            <v-col cols="6" sm="3" md="2">
              <v-text-field
                v-model="search"
                label="Buscar"
                hide-details
                single-line
                outlined
                dense
              >
                <template v-slot:append>
                  <v-icon
                    class="mt-1"
                    title="Buscar en los datos filtrados"
                    small
                  >
                    fas fa-search
                  </v-icon>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
        </template>
        <template v-slot:[`item.timestamp`]="{ item }">
          <span
            v-text="item.fecha"
          ></span>
        </template>
        <template v-slot:[`item.activo`]="{ item }">
          <span
            v-text="item.activo ? 'SI' : 'NO'"
          ></span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-icon
            color="info"
            title="Ver"
            small
            @click="open_dialog(item)"
          >
            fas fa-eye
          </v-icon>
        </template>
        <template v-slot:no-data>
          <v-alert
            class="mx-auto mt-4"
            max-width="400"
            type="warning"
            border="left"
            dense
            text
          >
            No hay turnos para los filtros seleccionados
          </v-alert>
        </template>
      </v-data-table>
    </v-col>
    <Turno
      v-model="dialog"
      :p_nuevo="nuevo"
      :p_turno="turno"
      @editar="editar_turno"
    />
  </v-row>
</template>

<script>
import moment from 'moment'
import Turno from '../components/Turno'
import FechaPicker from '../components/utils/FechaPicker'

export default {
  data () {
    return {
      panel: 0,
      search: '',
      load: false,
      nuevo: false,
      dialog: false,
      turnos: [],
      headers: [
        { text: 'Tipo', value: 'tipo' },
        { text: 'Estado', value: 'estado' },
        { text: 'Fecha', value: 'timestamp' },
        { text: 'Hora', value: 'hora' },
        { text: 'Cliente', value: 'cliente' },
        { text: 'Activo', value: 'activo', sortable: false, filterable: false },
        { text: 'Detalle', value: 'actions', sortable: false, filterable: false },
      ],
      turno: {},
      filtro: {
        tipo: null,
        estado: null,
        cliente: null,
        fecha_desde: moment(new Date()).format('DD/MM/YYYY'),
        fecha_hasta: null,
        activo: 1
      }
    }
  },
  created () {
    this.get_data()
  },
  components: {
    Turno,
    FechaPicker
  },
  methods: {
    async buscar () {
      this.load = true
      this.turnos = []
      this.uppercase()
      await this.$store.dispatch('get_turnos', this.filtro)
        .then((res) => {
          this.turnos = res
        })
        .catch(error => {
          this.$swal.fire({
            icon: 'error',
            title: 'Error al obtener los turnos',
            text: error,
          })
        })
      this.load = false
    },
    async get_data () {
      // obtiene los tipos de turnos solo si el array es vacio
      if (this.$store.state.tipos_turno.length == 0) {
        this.$store.state.loading = true
        await this.$store.dispatch('get_tipos_turno')
          .then(() => {
            // todo ok
          })
          .catch(error => {
            this.$swal.fire({
              icon: 'error',
              title: 'Error al obtener los tipos de turno',
              text: error,
            })
          })
        this.$store.state.loading = false
      }
      // obtiene los estados de turnos solo si el array es vacio
      if (this.$store.state.estados_turno.length == 0) {
        this.$store.state.loading = true
        await this.$store.dispatch('get_estados_turno')
          .then(() => {
            // todo ok
          })
          .catch(error => {
            this.$swal.fire({
              icon: 'error',
              title: 'Error al obtener los estados de los turnos',
              text: error,
            })
          })
        this.$store.state.loading = false
      }
    },
    editar_turno (item) {
      // actualiza el turno en el array
      let turno = this.turnos.find(turno => turno.id == item.id)
      Object.assign(turno, item)
    },
    open_dialog (item) {
      if (item) {
        this.nuevo = false
        this.turno = JSON.parse(JSON.stringify(item))
      } else {
        this.nuevo = true
        this.turno = {}
      }
      this.dialog = true
    },
    uppercase () {
      if (this.filtro.cliente) {
        this.filtro.cliente = this.filtro.cliente.toUpperCase()
      }
    },
    limpiar () {
      this.filtro = {
        tipo: null,
        estado: null,
        cliente: null,
        fecha_desde: moment(new Date()).format('DD/MM/YYYY'),
        fecha_hasta: null,
        activo: 1
      }
    }
  }
}
</script>